import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { fanTopics } from "@/mocks/fans";
import { siteInfo } from "@/mocks/site";
import { useSeo } from "@/hooks/useSeo";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import HeroCarousel from "./components/HeroCarousel";
import QuickLinks from "./components/QuickLinks";
import LatestNews from "./components/LatestNews";
import HomeSidebar from "./components/HomeSidebar";

export default function Home() {
  useSeo({
    title: "风间由美-官方资讯与最新动态",
    description:
      "风间由美官方网站，提供风间由美的最新新闻、作品介绍及动态更新，粉丝交流及资讯分享平台。",
    keywords: "风间由美,风间由美资讯,风间由美作品,风间由美动态,明星动态,个人品牌",
  });

  const sorted = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1));
  const featured = newsList.filter((n) => n.featured).slice(0, 3);
  const latest = sorted.slice(0, 5);
  const updates = sorted.slice(0, 4);
  const featuredWorks = worksList.slice(0, 3);

  return (
    <>
      <HeroCarousel items={featured.length ? featured : sorted.slice(0, 3)} />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-[1320px] flex-col items-center px-4 py-12 text-center md:px-6 md:py-16">
          <span className="text-xs font-medium tracking-[0.36em] text-primary-600">
            {siteInfo.brandEn} OFFICIAL
          </span>
          <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            风间由美官方网站
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteInfo.intro}
          </p>
        </div>
      </section>

      <QuickLinks />

      <section className="bg-background-100/60">
        <div className="mx-auto w-full max-w-[1320px] px-4 py-14 md:px-6 md:py-20">
          <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-8">
              <Reveal>
                <SectionHeading
                  eyebrow="Latest News"
                  title="最新新闻"
                  description="按发布时间倒序整理，点击即可查看完整资讯内容。"
                />
              </Reveal>
              <Reveal delay={80}>
                <div className="mt-4">
                  <LatestNews items={latest} />
                </div>
                <Link
                  to="/news"
                  className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
                >
                  查看全部新闻
                  <i className="ri-arrow-right-line" />
                </Link>
              </Reveal>
            </div>
            <aside className="lg:col-span-4">
              <Reveal delay={120}>
                <HomeSidebar updates={updates} topics={fanTopics.slice(0, 3)} />
              </Reveal>
            </aside>
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1320px] px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="Selected Works"
            title="精选作品推荐"
            description="从电影到音乐，挑选近年较受关注的作品，与你一起回顾。"
            action={
              <Link
                to="/works"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                全部作品
                <i className="ri-arrow-right-line" />
              </Link>
            }
          />
        </Reveal>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featuredWorks.map((work, i) => (
            <Reveal key={work.id} delay={i * 90}>
              <WorkCard item={work} />
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}